const NAVBAR_SCROLL_OFFSET = 96;

export function scrollToSectionId(id: string): boolean {
  const element = document.getElementById(id);
  if (!element) return false;

  const top = element.getBoundingClientRect().top + window.scrollY - NAVBAR_SCROLL_OFFSET;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  return true;
}

export function scrollToSectionWithRetry(id: string, maxAttempts = 30): void {
  let attempts = 0;

  const tryScroll = () => {
    if (scrollToSectionId(id)) return;

    attempts += 1;
    if (attempts < maxAttempts) {
      requestAnimationFrame(tryScroll);
    }
  };

  tryScroll();

  window.setTimeout(() => {
    scrollToSectionId(id);
  }, 150);
}
